<template>
  <div>
    <a-row>
      <a-col :span="20">
        <a-form layout="inline">
          <a-form-item label="国家">
            <a-select
              mode="multiple"
              :filter-option="filterOption"
              style="width: 240px"
              v-model:value="searchForm.countryIds"
              :max-tag-count="1"
              :options="countryOptionList"
              allowClear
            >
              <template #dropdownRender="{ menuNode: menu }">
                <div
                  style="margin-left: 10px;"
                  @mousedown="e => e.preventDefault()"
                >
                  <a-checkbox
                    v-model:checked="checkAll"
                    :indeterminate="yindeterminate"
                    class="mr10"
                    @change="onCheckAllChange"
                  />
                  <a-button size="small" class="mr10" @click="onChangeAll">
                    全选
                  </a-button>
                  <a-button size="small" @click="reverse">反选</a-button>
                </div>
                <a-divider style="margin: 4px 0" />
                <v-nodes :vnodes="menu" />
              </template>
            </a-select>
          </a-form-item>
          <a-form-item label="状态">
            <a-select
              style="width: 100px"
              v-model:value="searchForm.status"
              :options="statusOptionList"
              allowClear
            />
          </a-form-item>
        </a-form>
      </a-col>
      <a-col :span="4">
        <a-space>
          <a-button type="primary" @click="searchFormData">查询</a-button>
          <a-button type="default" @click="resetFormData">重置</a-button>
        </a-space>
      </a-col>
    </a-row>
  </div>
</template>
<script>
import { defineComponent, inject, reactive, toRefs } from 'vue'
export default defineComponent({
  name: 'AddressRule',
  components: {
    VNodes: (_, { attrs }) => {
      return attrs.vnodes
    }
  },
  setup() {
    const state = reactive({})
    return {
      ...toRefs(inject('initState')),
      ...toRefs(state)
    }
  }
})
</script>
